module.exports = __webpack_public_path__ + "img/180.19d66ec2.jpg";